import { useStaticQuery, graphql } from 'gatsby'
import _ from 'lodash'

export const queryBrands = () => {
  const query = useStaticQuery(
    graphql`
      {
        sanityBrand {
          id
          internal {
            type
            content
            contentDigest
            owner
          }
        }
        allSanityBrands {
          edges {
            node {
              id
              internal {
                type
                content
                contentDigest
                owner
              }
            }
          }
        }
      }
    `
  )
  const page = JSON.parse(query.sanityBrand.internal.content)
  const allBrands = []
  query.allSanityBrands.edges.forEach(edge => {
    let singleItem = {
      id: edge.node.id,
      data: JSON.parse(edge.node.internal.content)
    }
    allBrands.push(singleItem)
  })

  const allOrdered = _.orderBy(allBrands, ['data.title'], ['asc'])
  
  const groupedByCategory = _(allOrdered)
    .groupBy('data.category.title')
    .map((brands, category) => ({ category, brands }))
    .value()

  const groupedBySticker = _(allOrdered)
    .groupBy('data.mainSticker.title')
    .map((brands, sticker) => ({ sticker, brands }))
    .value()

  return Object.assign({}, page, {
    brands: allOrdered,
    categories: groupedByCategory,
    stickers: groupedBySticker
  })
}
